import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { TechProfileForm } from './tech-profile-form';
import { toast } from 'sonner';

const PREFILL_FIELDS = [
  'first_name',
  'last_name',
  'email',
  'phone',
  'address',
  'city',
  'state_province',
  'country',
  'postal_code',
] as const;

export function CreateTechPage({ basePath = '/crew/techs' }: { basePath?: string } = {}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const personIdParam = searchParams.get('person_id');
  const personId = personIdParam ? Number(personIdParam) : undefined;
  const initialValues = Object.fromEntries(
    PREFILL_FIELDS.map((field) => [field, searchParams.get(field) ?? '']),
  );

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button asChild variant="ghost" size="icon">
          <Link to={basePath}>
            <ArrowLeft className="h-5 w-5" />
          </Link>
        </Button>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            {personId ? 'Make Technician' : 'Add Technician'}
          </h1>
          <p className="text-gray-600 mt-1">
            {personId
              ? 'Create a technician profile linked to the existing person record'
              : 'Create a new technician profile'}
          </p>
        </div>
      </div>

      <TechProfileForm
        personId={personId}
        initialValues={initialValues}
        onCreated={(tech) => {
          toast.success('Technician created');
          navigate(`${basePath}/${tech.id}`);
        }}
        cancelAction={
          <Button type="button" variant="outline" asChild>
            <Link to={basePath}>Cancel</Link>
          </Button>
        }
      />
    </div>
  );
}
